import { Box, Layout } from '@src/shared/ui';
import React from 'react';
import { AlertInfo } from '../email-otp/components';
import { ProposalFooter } from '../proposal/components/proposal-footer';
import { useProposalController } from '../proposal/hooks';
import { ProposalConfirmed } from '../proposal/screen/confirmed';

export const ProposalConfirmedPage: React.FC = () => {
  const {
    toGenerateCode,
    isFixed,
    openModelMoreDetails,
    setOpenModelMoreDetails,
    validateForm,
  } = useProposalController();

  return (
    <Layout
      body={{
        fixed: openModelMoreDetails,
      }}
      header={{
        iconLeft: 'help',
        step: true,
      }}
      footer={{
        className: isFixed ? 'hidden md:flex' : 'flex',
      }}
      beforeGrid={<AlertInfo />}
      afterGrid={
        !openModelMoreDetails && (
          <Box
            className={`
            grid
            grid-cols-4
            mx-6

            sm:grid-cols-8
            sm:mx-10

            md:grid-cols-12
            md:mx-20
          `}
          >
            <ProposalFooter
              cannotHidden
              confirmed
              validateForm={validateForm}
              isFixed={isFixed}
              toContinue={toGenerateCode}
              openModelMoreDetails={openModelMoreDetails}
              setOpenModelMoreDetails={setOpenModelMoreDetails}
            />
          </Box>
        )
      }
    >
      <Box
        className={`
          ${
            openModelMoreDetails &&
            `
              fixed
            `
          }
          z-0
          col-span-4
          sm:col-span-8
          md:col-span-12
        `}
      >
        <ProposalConfirmed />
      </Box>
    </Layout>
  );
};
